var render = function render(){var _vm=this,_c=_vm._self._c;return _c('rs-pagination',{attrs:{"background":"","prev-text":"上一页","next-text":"下一页","current-page":_vm.pageNo,"page-sizes":[10,50,100,200],"page-size":_vm.pageSize,"layout":"total,prev, pager, next, sizes, jumper","total":_vm.pageTotal},on:{"size-change":_vm.handleSizeChange,"current-change":_vm.handleCurrentChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }